// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "dc0942e7f67fc8695fc1487c63c3edb6407b0060/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};